import { onNumberFieldPaste, onNumberKeydown } from "../../../utilities";
import useCashOnDeliverySettings from "../../../hooks/catalog/codSettings/useCashOnDeliverySettings";

const CashOnDeliverySettings = () => {
  const { onSubmit, register, handleSubmit, isSaving, areSettingsLoading } =
    useCashOnDeliverySettings();

  return (
    <div className="px-4">
      <div className="category__head headingBorder__b">
        <h2 className="titleHeading">Cash on Delivery Settings</h2>
      </div>

      {areSettingsLoading ? (
        <p className="py-20 text-center w-full">Loading...</p>
      ) : (
        <div>
          <div className="mx-auto max-w-[600px] bg-white p-6 mt-5">
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="enable-cod"
                {...register("is_cod_allowed")}
              />
              <label htmlFor="enable-cod">Enable cash on delivery</label>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-3 mt-7">
              <label htmlFor="cod-charges" className="shrink-0">
                Cash on delivery charges:
              </label>
              <input
                type="number"
                onKeyDown={(e) =>
                  onNumberKeydown(e, { isPositiveNumber: true })
                }
                onPaste={(e) =>
                  onNumberFieldPaste(e, { isPositiveNumber: true })
                }
                {...register("cod_value")}
                id="cod-charges"
                className="input grow"
              />
            </div>
          </div>

          <div className="grid place-items-center">
            <button
              onClick={handleSubmit(onSubmit)}
              disabled={isSaving}
              className="bg-secondary py-2 hover:opacity-80 font-medium rounded-md mt-6 px-10 transition-all duration-300"
            >
              Save
            </button>
          </div>
          {isSaving && (
            <p className="text-center text-sm text-gray-500 mt-2 w-full">
              Saving...
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CashOnDeliverySettings;
